// src/Pages/Stripe/StripeCancel/index.tsx

import React from "react";
import { useNavigate } from "react-router-dom";
import { useT } from "../../../i18n";

export const StripeCancel = () => {
  const t = useT();
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: "100vh", background: "#f5f5f5",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{
        background: "#fff", borderRadius: 18, padding: "48px 40px",
        maxWidth: 440, width: "100%", textAlign: "center",
        boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
      }}>
        {/* X icon */}
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
          <div style={{
            width: 64, height: 64, borderRadius: "50%",
            background: "#fef2f2", display: "flex",
            alignItems: "center", justifyContent: "center",
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
              stroke="#b91c1c" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </div>
        </div>

        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#111", margin: "0 0 10px" }}>
          {t("Pagamento cancelado")}
        </h1>
        <p style={{ fontSize: 14, color: "#888", margin: "0 0 28px", lineHeight: 1.6 }}>
          {t("Você cancelou o processo de pagamento.")}<br />
          {t("Nenhuma cobrança foi realizada.")}
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <button
            onClick={() => navigate("/establishment/subscription")}
            style={{
              padding: "11px 28px", background: "#00b6bc",
              color: "#fff", border: "none", borderRadius: 10,
              fontWeight: 700, fontSize: 14, cursor: "pointer",
            }}
          >
            {t("Tentar novamente")}
          </button>
          <button
            onClick={() => navigate("/home_establishment")}
            style={{
              padding: "11px 28px", background: "transparent",
              color: "#888", border: "1.5px solid #e0e0e0", borderRadius: 10,
              fontWeight: 600, fontSize: 14, cursor: "pointer",
            }}
          >
            {t("Voltar ao dashboard")}
          </button>
        </div>
      </div>
    </div>
  );
};